import { Navigate, Outlet } from 'react-router';
import { useUser } from '@/context/userContext';
import { USER_ROLE_MAP, UserRoleType } from '@/const/user';
import { getOpcoUserDetailsPath } from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/path/path';
import { getMasterAdminOrganizationUserDetailsPath } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/path/path';

export const PROFILE_ROLES: UserRoleType[] = [
  USER_ROLE_MAP.ORG_ADMIN,
  USER_ROLE_MAP.EXECUTOR,
  USER_ROLE_MAP.DEPOSITOR,
  USER_ROLE_MAP.RECIPIENT,
];

export const ProfileProtectedRoute = () => {
  const { currentRole, user, isOpcoRole, isMasterAdminRole } = useUser();

  // OpCo and Master Admin should be redirected to own user details page instead of profile page
  const getUserDetailsPath = () => {
    if (isOpcoRole) return getOpcoUserDetailsPath(user?.id);

    if (isMasterAdminRole) return getMasterAdminOrganizationUserDetailsPath(user?.id);
  };

  const userDetailsPagePath = getUserDetailsPath();
  const hasProfilePage = PROFILE_ROLES.includes(currentRole);

  if (hasProfilePage) {
    return <Outlet />;
  } else {
    return <Navigate to={userDetailsPagePath} />;
  }
};
